import React, { useState } from "react";
import axios from "axios";

function ModifyData() {
  const [folderId, setFolderId] = useState("");
  const [sizes, setSizes] = useState({});
  const [message, setMessage] = useState("");

  const [colorInput, setColorInput] = useState("");
  const [optionInput, setOptionInput] = useState("");
  const [priceInput, setPriceInput] = useState("");
  const [lengthInput, setLengthInput] = useState("");

 const handleAddSize = () => {
  const color = colorInput.trim();
  const value = optionInput.trim();
  const length = lengthInput.trim();
  const price = priceInput.trim() === "" ? null : Number(priceInput);

  if (!color || !value) {
    setMessage("Color and size are required.");
    return;
  }

  if (price !== null && (!Number.isFinite(price) || price < 0)) {
    setMessage("Enter a valid price.");
    return;
  }

  const newOption =
    length || price !== null
      ? {
          value,
          ...(length ? { length } : {}),
          ...(price !== null ? { price } : {}),
        }
      : value;

  setSizes((prev) => {
    const existing = prev[color] || [];

    const alreadyExists = existing.some((option) => {
      const existingValue =
        typeof option === "string" ? option : option.value;

      const existingLength =
        typeof option === "string" ? "" : option.length || "";

      return existingValue === value && existingLength === length;
    });

    if (alreadyExists) return prev;

    return {
      ...prev,
      [color]: [...existing, newOption],
    };
  });

  setOptionInput("");
  setLengthInput("");
  setPriceInput("");
  setMessage("");
};

 const handleRemoveSize = (color, optionValue, optionLength = "") => {
  setSizes((prev) => {
    const updated = { ...prev };

    updated[color] = (updated[color] || []).filter((option) => {
      const value =
        typeof option === "string" ? option : option.value;

      const length =
        typeof option === "string" ? "" : option.length || "";

      return !(value === optionValue && length === optionLength);
    });

    if (updated[color].length === 0) {
      delete updated[color];
    }

    return updated;
  });
};

  const handleModifyData = async () => {
    try {
      const response = await axios.put(
        `https://api.malidag.com/modify/${folderId}`,
        { sizes }
      );

      setMessage("Data updated successfully!");
      console.log("Response:", response.data);
    } catch (error) {
      console.error("Error modifying data:", error);
      setMessage("Failed to update data.");
    }
  };

  return (
    <div>
      <h2>ADD SIZE Data</h2>

      <div>
        <label>Folder ID:</label>
        <input
          type="text"
          placeholder="Enter folder ID"
          value={folderId}
          onChange={(e) => setFolderId(e.target.value)}
        />
      </div>

      <div>
        <label>Add Option:</label>

        <input
          type="text"
          placeholder="Color"
          value={colorInput}
          onChange={(e) => setColorInput(e.target.value)}
        />

        <input
          type="text"
          placeholder="Size / Storage"
          value={optionInput}
          onChange={(e) => setOptionInput(e.target.value)}
        />

        <input
        type="text"
        placeholder="Length / Inseam (optional, e.g. 30, 32)"
        value={lengthInput}
        onChange={(e) => setLengthInput(e.target.value)}
      />

        <input
          type="number"
          placeholder="Price"
          value={priceInput}
          onChange={(e) => setPriceInput(e.target.value)}
        />

        <button onClick={handleAddSize}>Add Option</button>
      </div>

      <div>
        <h3>Remove Options:</h3>

        {Object.keys(sizes).length > 0 ? (
          Object.entries(sizes).map(([color, options]) => (
            <div key={color}>
              <strong>{color}:</strong>

             {options.map((option, index) => {
  const value = typeof option === "string" ? option : option.value;
  const length =
    typeof option === "object" ? option.length || "" : "";
  const price =
    typeof option === "object" ? option.price : null;

  return (
    <span
      key={`${color}-${value}-${length}-${index}`}
      style={{
        display: "inline-block",
        margin: "5px",
        padding: "5px",
        backgroundColor: "#f8d7da",
        color: "#721c24",
        borderRadius: "4px",
        cursor: "pointer",
      }}
      onClick={() => handleRemoveSize(color, value, length)}
    >
      Size: {value}
      {length ? ` | Length: ${length}` : ""}
      {price != null ? ` | $${price}` : ""}
      {" ✕"}
    </span>
  );
})}
            </div>
          ))
        ) : (
          <p>No options to remove.</p>
        )}
      </div>

      <pre>{JSON.stringify(sizes, null, 2)}</pre>

      <button onClick={handleModifyData}>Modify Data</button>

      {message && <p>{message}</p>}
    </div>
  );
}

export default ModifyData;